import React from "react";
//#region types
import { UserProps } from "models/propTypes/userProfilePropTypes";
//#endregion
//#region components
import Person from "./person";
import { useEmployeeHelpers } from "components/employee";
//#endregion
import { UrlHelper } from "utils/helpers";

const UserProfileLink: React.FC<UserProps> = (props) => {
  const { id, disableLink } = props;
  const { canView } = useEmployeeHelpers();

  const url = UrlHelper.formatPath(`/Employee/${id}`);

  return id && canView(id) && !disableLink ? <Person {...props} href={url} /> : <Person {...props} />;
};

export default UserProfileLink;
